<template>
  <div class="integration-diff-table-component">
    <table class="table">
      <tbody>
      <tr>
        <td>
          <font-awesome-icon
              :icon="integrationType === 'web' ? 'fa-regular fa-xmark-circle' : 'fa-regular fa-check-circle'"
              :color="integrationType === 'web' ? 'red' : 'green'"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Conexão com alto desempenho</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              :icon="integrationType === 'web' ? 'fa-regular fa-xmark-circle' : 'fa-regular fa-check-circle'"
              :color="integrationType === 'web' ? 'red' : 'green'"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Conta Reconhecida Oficial WhatsApp</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              :icon="integrationType === 'web' ? 'fa-regular fa-xmark-circle' : 'fa-regular fa-check-circle'"
              :color="integrationType === 'web' ? 'red' : 'green'"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Atualizações de novas funções</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              :icon="integrationType === 'web' ? 'fa-regular fa-xmark-circle' : 'fa-regular fa-check-circle'"
              :color="integrationType === 'web' ? 'red' : 'green'"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Análise de desempenho campanha</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              :icon="integrationType === 'web' ? 'fa-regular fa-xmark-circle' : 'fa-regular fa-check-circle'"
              :color="integrationType === 'web' ? 'red' : 'green'"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Controle da qualidade da conta</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              :icon="integrationType === 'web' ? 'fa-regular fa-xmark-circle' : 'fa-regular fa-check-circle'"
              :color="integrationType === 'web' ? 'red' : 'green'"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Sincronização de Contatos</strong></span>
        </td>
      </tr>
      <tr>
        <td>
          <font-awesome-icon
              :icon="integrationType === 'web' ? 'fa-regular fa-xmark-circle' : 'fa-regular fa-check-circle'"
              :color="integrationType === 'web' ? 'red' : 'green'"
              size="1half-x"
          />
        </td>
        <td class="is-flex is-justify-content-start is-align-content-center">
          <span><strong>Sincronização de Mensagens</strong></span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {

  name: 'integrationDiffTable',

  props: {
    integrationType: {
      required: true,
      type: String
    }
  }

}

</script>

<style>
.fa-1half-x {
  font-size: 1.5em;
}
</style>